import React from 'react';

const IconLoader = () => <div>loading...</div>;

export default IconLoader;
